import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AlertService } from 'app/services/alert.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { SquareOrdersErrorsAdapterService } from '../services/square-orders-errors-adapter.service';
import { SquareOrdersErrorsService } from '../services/square-orders-errors.service';
import * as SquareOrdersErrorsActions from './square-orders-errors.actions';

@Injectable()
export class SquareOrdersErrorsEffects {
    private _actions$ = inject(Actions);
    private _squareOrdersErrorsService = inject(SquareOrdersErrorsService);
    private _squareOrdersErrorsAdapterService = inject(
        SquareOrdersErrorsAdapterService
    );
    private _alertService = inject(AlertService);

    messages = {
        unknownError: 'Unknown error',
    };

    // -----------------------------------------------------------
    // @ Effects
    // -----------------------------------------------------------

    getAllSquareOrdersErrors$ = createEffect(() =>
        this._actions$.pipe(
            ofType(SquareOrdersErrorsActions.loadSquareOrdersErrors),
            switchMap((action) =>
                this._squareOrdersErrorsService.getAll(action.params).pipe(
                    map((res) =>
                        SquareOrdersErrorsActions.loadSquareOrdersErrorsSuccess(
                            {
                                squareOrdersErrors:
                                    this._squareOrdersErrorsAdapterService.adaptList(
                                        res.data
                                    ),
                            }
                        )
                    ),
                    catchError((error) =>
                        of(
                            SquareOrdersErrorsActions.loadSquareOrdersErrorsFailure(
                                {
                                    error:
                                        error?.error?.message ||
                                        this.messages.unknownError,
                                }
                            )
                        )
                    )
                )
            )
        )
    );

    // -----------------------------------------------------------
    // @ Side Effects (alerts)
    // -----------------------------------------------------------

    onSquareOrdersErrorsActionFailure$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(SquareOrdersErrorsActions.loadSquareOrdersErrorsFailure),
                tap((action) =>
                    this._alertService.showAlert(action.error, 'error')
                )
            ),
        { dispatch: false }
    );
}
